interface SiderTitleProps {
  collapsed: boolean;
}

export const SiderTitleComponent = ({ collapsed }: SiderTitleProps) => {
  return (
    <div className="app-brand" data-testid="app-brand">
      <img
        className="app-brand-logo"
        src="/Automart Logo Transparent BG.png"
        alt="Automart Logo"
      />
      {!collapsed && (
        <div className="app-brand-text">
          <span className="app-brand-name">Installment Admin</span>
          <span className="app-brand-sub">Automart</span>
        </div>
      )}
    </div>
  );
};
